import React from 'react'

import csx from 'classnames'
import htmr from 'htmr'
import styled from 'styled-components'

import { above, colors, fontSize, space } from '../../style/design-system'
import shortcodeParser from '../../utils/filters/shortcodeParser'
import footnoteLanguage from '../../utils/static-data/footnoteLanguage'
import Column from '../grid/Column'
import Container from '../grid/Container'
import Row from '../grid/Row'

const FormWrapperGray = ({
  className,
  children,
  heading,
  disclaimer,
  showDefaultContent,
  columnProps,
  headingTag,
}) => (
  <div className={className}>
    <Container className="py-8 py-md-10">
      <Row>
        <Column lg={columnProps}>
          {heading && (
            <div className={csx(headingTag, 'mt-0 blue text-center')}>
              {htmr(heading)}
            </div>
          )}
          {showDefaultContent && (
            <div className="text-left text-lg-center">
              <h2 className="h1 blue">Let’s talk about it.</h2>
              <p>
                <em>You have questions. We have answers.</em>
              </p>
              <p>
                Complete this form and we’ll email you info on how to get
                started at UMA, financial aid if qualified, selecting a program,
                and more. We’ll also give you a call to ensure your questions
                are answered so you can decide which program is right for you.
              </p>
            </div>
          )}
          {children}
          {disclaimer && (
            <p className="disclaimer text-left mb-12 mb-md-6">
              <small className="mt-8">{htmr(disclaimer)}</small>
            </p>
          )}
        </Column>
      </Row>
    </Container>
  </div>
)

FormWrapperGray.defaultProps = {
  disclaimer: shortcodeParser(footnoteLanguage.formDisclaimer),
  showDefaultContent: true,
  columnProps: { size: 8, offset: 2 },
  headingTag: 'h1',
}

export default styled(FormWrapperGray)`
  align-items: center;
  background-color: ${colors.dev.gray.h()};
  display: flex;
  text-align: center;
  overflow: auto;

  ${above.md`
    padding: ${space.h} 0;
  `}

  input, select {
    background-color: #fff;
    border: 0;
    cursor: pointer;
    padding: ${space.c};
    width: 100%;
  }

  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  form {
    display: flex;
    flex-wrap: wrap;
    text-align: left;
    justify-content: space-between;
  }

  .input-wrap {
    flex: 0 0 100%;
    margin: 0.625rem 0;

    ${above.md`
      margin: 0.9375rem 0;
      flex: 0 0 50%;

      // IE fix bc IE doesn't include padding in box-sizing, 
      // which causes wrapping of flex items
      input, .select-wrap, .label-and-error {
        width: calc(100% - 1.25rem);
      }

      &:nth-of-type(even) {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }
    `}
  }

  button[type='submit'] {
    border: none;
    color: #fff;
    margin: 0 auto;
    padding: ${space.c} ${space.e};
  }

  .button-wrap {
    margin: ${space.e} 0;
  }

  .label-and-error {
    align-items: baseline;
    display: flex;
    justify-content: space-between;

    .error {
      background-color: transparent;
      color: ${colors.dev.red.f()};
    }
  }

  .error,
  .error p {
    background-color: ${colors.dev.red.f()};
    border-radius: 2px;
    font-size: ${fontSize.d};
    padding: ${space.b};

    p {
      color: #fff;
      font-weight: 700;
      margin: 0;
    }

    a {
      color: #fff;
      text-decoration: underline;
    }
  }

  .button-wrap {
    flex: 0 0 100%;
  }

  .disclaimer {
    line-height: 1;
  }

  .fl-only {
    font-size: 0.8rem;
    margin-top: ${space.c};
  }

  .pht-state-disclaimer {
    font-size: 0.8rem;
    font-style: italic;
    margin-top: ${space.c};
  }
`
